import { useQuery } from "@tanstack/react-query";
import { useAtomValue, useSetAtom } from "jotai";

import TenantAPI from "../../api/TenantAPI";
import { FormBuilderSaved } from "../../../types/FormBuilderInterfaces";
import { setSchemaAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";

const useForm = (formID: string, tenantID: string, enabled = true) => {
  const setSchema = useSetAtom(setSchemaAtom);
  const tenantIDAtomValue = useAtomValue(tenantIDAtom);

  const form = useQuery<FormBuilderSaved>({
    queryKey: [tenantID || tenantIDAtomValue, "record", "Forms", formID],
    queryFn: () =>
      TenantAPI.getPublicFormByID(formID, tenantID).then((data) => {
        setSchema({ CRM: { Modules: [data.data.data.module] } });

        return data.data.data;
      }),
  });

  return {
    form: form.data?.form,
    module: form.data?.module,
    formLoading: form.isLoading,
  };
};

export default useForm;
